module.exports = __webpack_public_path__ + "img/awards-3-s.43ba68e7.png";